module.exports = __webpack_public_path__ + "img/DE01780.d61e683a.png";